import React from 'react';
import { ChevronRight } from 'lucide-react';
import Container from 'assets/images/Container.png'
import Img_hero from 'assets/images/Container-1.png'


const Hero = () => {
  return (
    <div 
      className="min-h-[calc(100vh-80px)] md:min-h-[calc(100vh-140px)] flex items-center bg-gray-50"
      style={{
        backgroundImage: `url(${Container})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
<div className='bg-red-600/80 w-full h-full'>     
      {/* Contenido principal */}
      <div className="relative z-10 w-full lg:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:py-8 md:py-16">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-8 md:gap-12 pt-12 lg:pt-0">
          
          {/* Div de información - Contenido principal */}
          <div className="flex-1 text-white space-y-6 md:space-y-8 text-center lg:text-left order-2 lg:order-1">
            <div className="space-y-4 md:space-y-6">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                <span className="text-white">AI-Powered Experts</span>
                <br />
                <span className="text-white">
                  Intelligent automation that turns leads into loyal customers.
                </span>
              </h1>
              
              <div className="space-y-3 md:space-y-4 text-base sm:text-lg lg:text-xl text-white">
                <p className="font-semibold">
                  Bold Design. Smart Strategy. Real Results. Let's Grow Your Business
                </p>
                <p className="text-white">
                  SEO • Social Media • Reviews • AI Marketing • Web Design
                </p>
              </div>
            </div>

            {/* Botón CTA */}
            <div className="pt-4 flex justify-center lg:justify-start">
              <button className="w-fit bg-white text-red-600 px-6 md:px-8 py-3 md:py-4 rounded-lg font-bold text-base md:text-lg hover:bg-gray-100 transition-colors flex items-center space-x-2 shadow-lg">
                <span>GET STARTED</span>
                <ChevronRight size={20} />
              </button>
            </div>

            {/* Badge de Yelp */}
            <div className="flex flex-col sm:flex-row items-center lg:items-end space-y-2 sm:space-y-0 sm:space-x-4 pt-6 md:pt-8">
              <div className="bg-white text-red-600 px-3 md:px-4 py-2 rounded-full flex items-center space-x-2">
                <div className="w-5 h-5 md:w-6 md:h-6 bg-red-600 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-xs md:text-sm">★</span>
                </div>
                <span className="text-xs md:text-sm font-semibold">YELP ADVERTISING PARTNER</span>
              </div>
              <div className="text-white/80 text-xs md:text-sm text-center lg:text-right">
                Official Yelp Advertising Partner
              </div>
            </div>
          </div>

          {/* Div de imagen - Debajo del contenido */}
          <div className="flex-1 flex justify-center order-1 lg:order-2">
            <img
              src={Img_hero}
              alt="Professional woman with tablet showing digital marketing dashboard"
              className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-2xl xl:max-w-3xl h-auto object-contain"
            />
          </div>
        </div>
      </div>
      </div> 

    </div>
  );
};

export default Hero;
